import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles<Theme>((theme) => ({
  mainFrame: {
    width: '100%',
    alignItems: 'center'
  },
  title: {
    marginBottom: '1rem'
  }
}));
